<script lang="ts">
  export let fontSize: "xxs" | "xs" | "md" | "xl" | "xxl" = "md";
  export let group: any;
  export let value: any;
</script>

<div class="flex items-center">
  <input
    id={value}
    {value}
    checked
    type="radio"
    class="w-4 h-4 accent-primary-500"
    bind:group
    on:change
  />
  <label for={value} class="grow ml-2 text-{fontSize} font-medium text-gray-900 dark:text-gray-300"
    ><slot /></label
  >
</div>
